/* Extracted from sections/featured-product.liquid (inline script).
   One initializer per section instance; safe for multiple instances per page
   and re-runs on Shopify theme-editor section reloads. */

function initFeaturedProduct(root) {
  if (!root || root.dataset.fpInit === '1') return;
  root.dataset.fpInit = '1';


      /* ---------- entrance ---------- */
      if (root.classList.contains('fp-animated')) {
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced || !('IntersectionObserver' in window)) {
          root.classList.add('is-in-view');
        } else {
          var io = new IntersectionObserver(function (entries, o) {
            entries.forEach(function (en) {
              if (en.isIntersecting) { root.classList.add('is-in-view'); o.unobserve(en.target); }
            });
          }, { threshold: 0.12 });
          io.observe(root);
        }
      }

      /* ---------- data ---------- */
      var variants = [];
      try { variants = JSON.parse(root.querySelector('[data-fp-json]').textContent); } catch (e) {}
      var moneyFormat = root.getAttribute('data-money-format') || '';
      var context = root.getAttribute('data-context');
      var qtyInput = root.querySelector('[data-fp-qty-input]');

      function fpMoney(cents) {
        var dollars = Math.floor(Math.abs(cents) / 100);
        var centsPart = String(Math.abs(cents) % 100).padStart(2, '0');
        function group(n, sep) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
        var val;
        if (moneyFormat.indexOf('amount_no_decimals') >= 0) val = group(Math.round(cents / 100), ',');
        else if (moneyFormat.indexOf('amount_with_comma_separator') >= 0) val = group(dollars, '.') + ',' + centsPart;
        else if (moneyFormat.indexOf('amount_with_apostrophe_separator') >= 0) val = group(dollars, "'") + '.' + centsPart;
        else if (moneyFormat.indexOf('amount_with_space_separator') >= 0) val = group(dollars, ' ') + ',' + centsPart;
        else val = group(dollars, ',') + '.' + centsPart;
        if (!moneyFormat) return '$' + val;
        return moneyFormat.replace(/\{\{\s*amount(_\w+)?\s*\}\}/, val);
      }

      /* ---------- quantity ---------- */
      root.querySelectorAll('[data-fp-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.getAttribute('data-fp-qty'), 10));
          qtyInput.value = v;
        });
      });

      /* ---------- size chart modal ---------- */
      root.querySelectorAll('[data-fp-sc-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dlg = root.querySelector('[data-fp-modal]');
          if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
          else if (dlg) dlg.setAttribute('open', '');
        });
      });
      var scDlg = root.querySelector('[data-fp-modal]');
      if (scDlg) {
        scDlg.addEventListener('click', function (e) {
          if (e.target === scDlg) scDlg.close();
        });
        var scClose = scDlg.querySelector('[data-fp-modal-close]');
        if (scClose) scClose.addEventListener('click', function () { scDlg.close(); });
      }

      /* ---------- gallery ---------- */
      var thumbs = root.querySelectorAll('[data-fp-thumb]');
      var mediaImgs = root.querySelectorAll('[data-media-id]');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var id = thumb.getAttribute('data-fp-thumb');
          thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
          mediaImgs.forEach(function (img) { img.classList.toggle('is-active', img.getAttribute('data-media-id') === id); });
        });
      });

      /* ---------- pairs carousel ---------- */
      var track = root.querySelector('[data-fp-pairs-track]');
      if (track) {
        var step = function () { var card = track.querySelector('.fp__pair-card'); return card ? card.offsetWidth + 12 : 300; };
        var prev = root.querySelector('[data-fp-pairs-prev]');
        var next = root.querySelector('[data-fp-pairs-next]');
        if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      }

      /* ---------- accessories: add selected ---------- */
      var accBtn = root.querySelector('[data-fp-acc-add]');
      if (accBtn) {
        accBtn.addEventListener('click', function () {
          var checked = root.querySelectorAll('[data-fp-acc]:checked');
          if (!checked.length) return;
          var items = Array.prototype.map.call(checked, function (el) {
            return { id: parseInt(el.value, 10), quantity: 1 };
          });
          accBtn.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function (r) { return r.json(); }).then(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            accBtn.textContent = accBtn.getAttribute('data-done-label');
            setTimeout(function () {
              accBtn.textContent = accBtn.getAttribute('data-label');
              accBtn.disabled = false;
            }, 2000);
          }).catch(function () { accBtn.disabled = false; });
        });
      }

      /* ---------- variant selection ---------- */
      var opts = root.querySelectorAll('[data-fp-opt]');
      var sel = [];
      function findVariant() {
        var matches = variants.filter(function (v) {
          return v.options.every(function (o, i) { return !sel[i] || o === sel[i]; });
        });
        return matches.find(function (v) { return v.available; }) || matches[0];
      }
      function refreshPickup(vid) {
        var wrap = root.querySelector('[data-fp-pickup]');
        if (!wrap || wrap.getAttribute('data-fp-pickup') !== 'auto') return;
        var url = new URL(window.location.href);
        url.searchParams.set('section_id', root.getAttribute('data-section-id'));
        url.searchParams.set('variant', vid);
        fetch(url.toString()).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-fp-pickup]');
          if (fresh) wrap.innerHTML = fresh.innerHTML;
        }).catch(function () {});
      }
      function applyVariant(v) {
        if (!v) return;
        var input = root.querySelector('[data-fp-variant-input]');
        if (input) input.value = v.id;
        var price = root.querySelector('[data-fp-price]');
        if (price) price.textContent = fpMoney(v.price);
        var compare = root.querySelector('[data-fp-compare]');
        if (compare) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compare.textContent = fpMoney(v.compare_at_price);
            compare.hidden = false;
          } else { compare.hidden = true; }
        }
        var atcPrice = root.querySelector('[data-fp-atc-price-value]');
        if (atcPrice) atcPrice.textContent = fpMoney(v.price);
        var atc = root.querySelector('[data-fp-atc]');
        if (atc) {
          if (v.available) {
            atc.disabled = false;
            atc.querySelector('[data-fp-atc-label]').textContent = atc.getAttribute('data-label');
          } else {
            atc.disabled = true;
            atc.querySelector('[data-fp-atc-label]').textContent = atc.getAttribute('data-sold-out');
          }
        }
        /* stock */
        var stock = root.querySelector('[data-fp-stock]');
        if (stock) {
          var threshold = parseInt(stock.getAttribute('data-threshold'), 10) || 12;
          var textEl = stock.querySelector('[data-fp-stock-text]');
          var fillEl = stock.querySelector('[data-fp-stock-fill]');
          if (v.available && typeof v.inventory_quantity === 'number' && v.inventory_quantity > 0 && v.inventory_quantity <= threshold) {
            stock.hidden = false;
            textEl.textContent = (stock.getAttribute('data-template') || 'Hurry, only {n} items left in stock!').replace('{n}', v.inventory_quantity);
            fillEl.style.width = Math.min(100, Math.round(v.inventory_quantity / threshold * 100)) + '%';
          } else { stock.hidden = true; }
        }
        /* labels */
        v.options.forEach(function (val, i) {
          var label = root.querySelector('[data-fp-opt-label="' + i + '"]');
          if (label) label.textContent = val;
        });
        /* media */
        if (v.featured_media && v.featured_media.id) {
          var mid = String(v.featured_media.id);
          mediaImgs.forEach(function (img) { img.classList.toggle('is-active', img.getAttribute('data-media-id') === mid); });
          thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-fp-thumb') === mid); });
        }
        if (context === 'pdp') {
          try { history.replaceState({}, '', '?variant=' + v.id); } catch (e) {}
        }
        refreshPickup(v.id);
      }
      opts.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var i = parseInt(btn.getAttribute('data-option-index'), 10);
          var val = btn.getAttribute('data-value');
          sel[i] = val;
          opts.forEach(function (b) {
            if (b.getAttribute('data-option-index') === String(i)) {
              b.classList.toggle('is-active', b === btn);
            }
          });
          applyVariant(findVariant());
        });
      });
      /* seed selection + stock template from server-rendered state */
      var currentInput = root.querySelector('[data-fp-variant-input]');
      if (currentInput) {
        var current = variants.find(function (v) { return String(v.id) === currentInput.value; });
        if (current) {
          sel = current.options.slice();
          opts.forEach(function (b) {
            var i = b.getAttribute('data-option-index');
            if (String(current.options[parseInt(i, 10)]) === b.getAttribute('data-value')) b.classList.add('is-active');
          });
        }
      }
      var stockBlock = root.querySelector('[data-fp-stock]');
      if (stockBlock) {
        applyVariant(variants.find(function (v) { return String(v.id) === String(currentInput ? currentInput.value : ''); }) || variants[0]);
      }
}

function initAllFeaturedProducts(scope) {
  (scope || document).querySelectorAll('[id^="FeaturedProduct-"]').forEach(initFeaturedProduct);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () { initAllFeaturedProducts(); });
} else {
  initAllFeaturedProducts();
}
document.addEventListener('shopify:section:load', function (event) {
  initAllFeaturedProducts(event.target);
});
